import { render, staticRenderFns } from "./KarmaCatalogueView.vue?vue&type=template&id=e2b16164&scoped=true&"
import script from "./KarmaCatalogueView.vue?vue&type=script&lang=js&"
export * from "./KarmaCatalogueView.vue?vue&type=script&lang=js&"
import style0 from "./KarmaCatalogueView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./KarmaCatalogueView.vue?vue&type=style&index=1&id=e2b16164&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b16164",
  null
  
)

export default component.exports